module.exports = __webpack_public_path__ + "media/images/winery-winery-m-0d1d43e880bddb7bdcc1e9a5fabc1b88.jpg";